import { Injectable } from '@angular/core';
import { AttachmentService } from 'src/sb-tools/typescript/services/attachment.service';

@Injectable({ providedIn: 'root' })
export class PrintService {
    constructor(private attachmentService: AttachmentService) {}

    printAttachment(attachmentUrl: string): void {
        this.attachmentService.downloadFile(attachmentUrl).subscribe((data) => {
            const blobUrl = URL.createObjectURL(data);

            let printedIframe = document.getElementById('printedFile') as HTMLIFrameElement;

            if (printedIframe) {
                printedIframe.src = blobUrl;
                printedIframe.style.display = 'block';
            } else {
                printedIframe = document.createElement('iframe');
                printedIframe.id = 'printedFile';
                printedIframe.src = blobUrl;
                printedIframe.setAttribute('role', 'document');
                printedIframe.title = 'Print file';
                document.body.appendChild(printedIframe);
            }

            printedIframe.onload = function (event: any) {
                const iframeDocument = event.target.contentDocument || event.target.contentWindow?.parent?.document;

                if (iframeDocument) {
                    const style = iframeDocument.createElement('style');
                    const css =
                        '@media print {\n' +
                        '    img {\n' +
                        '        max-width: 100%;\n' +
                        '        max-height: 100%;\n' +
                        '    }\n' +
                        '}\n';
                    style.appendChild(iframeDocument.createTextNode(css));
                    iframeDocument.head.appendChild(style);
                }

                if (event.target.contentWindow) {
                    event.target.contentWindow.focus();
                    event.target.contentWindow.print();
                }

                setTimeout(() => {
                    event.target.style.display = 'none';
                }, 500);
            };
        });
    }
}
